export default {
  name: 'inventaire-filtres',
  props: {
    filter: { type: [String, Object], default: '' },
    authorFilter: { type: [String, Object], default: '' },
    authorOptions: { type: Array, default: () => [] },
    month: { type: [String, Object], default: '' },
    monthOptions: { type: Array, default: () => [] },
    dateFilter: { type: [String, Object], default: '' },
    dateOptions: { type: Array, default: () => [] },
  },
}
